import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import UpsertProductLine from "./UpsertProductLine.graphql";

export default function useUpsertProductLine(productLine) {
    return useMutation(
        gql(UpsertProductLine),
        {
            variables: {
                productLine,
            },
            refetchQueries: ["Brand"],
        },
    );
}
